import ApiClient from '@/api/api-client'

export default function() {
    return {
        getDefaultConsents: function() {
            return ApiClient.get('/default-consents')
        }
    }
}
